module.exports = __webpack_public_path__ + "static/media/tala-lagt.aa5a8e98.mp3";